/**
 * Created by Sebastian Bender on 16.03.2017.
 */
var XMLNode = require('../xml/XMLNode');
var Cell	= require('./Cell');

/**
 * The Row is representing a single row according to the Office Open
 * XML standard. A Row provides information about its index (line
 * number) and can contain several Cell objects.
 *
 * @class
 */
function Row() {
	XMLNode.call(this, Row.metadata);
}

Row.prototype = Object.create(XMLNode.prototype);
Row.prototype.constructor = Row;

Row.metadata = {
	tag: 'row',
	attributes: [
		{
			id: 'reference',
			name: 'r',
			value: ''
		},
		{
			id: 'spans',
			name: 'spans',
			value: '1:1'
		}
	]
};

/**
 * Calculates the Office Open XML Spreadsheet column reference for a
 * numeric value. Referring to the standard, the column is described
 * as a alphabetical value consisting of at least one uppercase character.
 * This function maps these alphabetical representation to numerical
 * zero-based indices.
 *
 * i.E. the column index 27 (which is the 28th column) results in 'AB'
 *
 * @param {number} nIndex - Numerical index for the requested column
 * @returns {string} - The alphabetical column reference for the given index.
 */
Row.getColumnReferenceByIndex = function(nIndex) {
	return nIndex < 26 ?
		String.fromCharCode(65 + nIndex) :
		Row.getColumnReferenceByIndex(Math.floor(nIndex / 26) - 1) + String.fromCharCode(65 + (nIndex % 26));
};


/**
 * Update the 'spans' attribute on this particular {@link Row} for
 * optimization purposes. This property optimizes the loading and
 * rendering in Microsoft Excel.
 *
 * @private
 */
Row.prototype._updateSpans = function() {
	this.spans.value = '1:' + this.childs.length;
};

/**
 * Adds the specified {@link Cell} to the current {@link Row}. If the
 * current row already has a reference or style, it will propagate
 * this information to the newly added Cell.
 *
 * @param {object} oCell - Instance of Excel.objects.Cell
 */
Row.prototype.addCell = function(oCell) {
	var count;

	if (!oCell || !(oCell instanceof Cell)) {
		return;
	}

	count = this.childs.push(oCell);
	this._updateSpans();

	/* Applies the cell reference if row reference is already present */
	if (this.reference.value) {
		oCell.setReference(Row.getColumnReferenceByIndex(count - 1) + this.reference.value);
	}

	if (this.style) {
		oCell.setStyle(this.style.value);
	}
};


/**
 * Updates the reference of the current {@link Row}. The Row reference
 * represents the line number within the Sheet. It will
 * automatically update all assigned Cell references.
 *
 * @param {string} sReference - Row number within the sheet
 */
Row.prototype.setReference = function(sReference) {
	var i, reference;

	reference = typeof sReference == 'number' ? String(sReference) : sReference;
	if (!reference || !reference.match(/^[1-9]+[0-9]*$/g)) {
		return;
	}

	/* Only update if necessary */
	if (this.reference.value != reference) {
		this.reference.value = reference;
		for (i = 0; i < this.childs.length; i++) {
			this.childs[i].setReference(Row.getColumnReferenceByIndex(i) + reference);
		}
	}
};

/**
 * Applies the given {@link Style} to the current {@link Row}.
 *
 * @param {(number|string)} nStyle - A number or string representing the Style id
 */
Row.prototype.setStyle = function(nStyle) {
	var i, style;

	if (!this.style) {
		style = this.addAttribute({name: 's'});
		Object.defineProperty(this, 'style', {value: style});
	}

	this.style.value = nStyle;
	for (i = 0; i < this.childs.length; i++) {
		this.childs[i].setStyle(nStyle);
	}
};

module.exports = Row;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/data/Row.js
// module id = 10
// module chunks = 0